module.exports = __webpack_public_path__ + "img/hanhua1.2766309f.jpg";